import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'demandDate',
  standalone: true
})
export class DemandDatePipe implements PipeTransform {
  transform(value: Date | string, locale: string): string {
    return new Intl.DateTimeFormat(locale, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      month: 'short',
      day: 'numeric',
    }).format(new Date(value));
  }
}
